var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container-fluid",
    attrs: {
      id: "elements"
    }
  }, [_c("div", {
    staticClass: "mb-4",
    attrs: {
      id: "research"
    }
  }, [_c("b-row", [_c("b-col", {
    staticClass: "mb-3",
    attrs: {
      cols: "12",
      lg: "3"
    }
  }, [_c("label", {
    attrs: {
      for: "ldate"
    }
  }, [_vm._v("Date de début")]), _vm._v(" "), _c("b-form-datepicker", {
    attrs: {
      "today-button": "",
      locale: "fr",
      "label-today-button": "Aujourd'hui"
    },
    model: {
      value: _vm.from_date,
      callback: function ($$v) {
        _vm.from_date = $$v;
      },
      expression: "from_date"
    }
  }), _vm._v(" "), _c("label", {
    staticClass: "mt-3",
    attrs: {
      for: "ldate"
    }
  }, [_vm._v("Date de fin")]), _vm._v(" "), _c("b-form-datepicker", {
    attrs: {
      "today-button": "",
      locale: "fr",
      "label-today-button": "Aujourd'hui"
    },
    model: {
      value: _vm.to_date,
      callback: function ($$v) {
        _vm.to_date = $$v;
      },
      expression: "to_date"
    }
  })], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-3",
    attrs: {
      cols: "12",
      lg: "3"
    }
  }, [_c("b-form-group", {
    staticClass: "mb-3",
    attrs: {
      label: "Type de recette"
    }
  }, [_c("b-form-radio-group", {
    attrs: {
      options: _vm.options_radio,
      buttons: "",
      "button-variant": "outline-primary",
      name: "radios-btn-default"
    },
    model: {
      value: _vm.selected_radio,
      callback: function ($$v) {
        _vm.selected_radio = $$v;
      },
      expression: "selected_radio"
    }
  })], 1), _vm._v(" "), _c("label", {
    attrs: {
      for: "ldate"
    }
  }, [_vm._v("Actions")]), _vm._v(" "), _c("b-button", {
    staticClass: "mt-2",
    attrs: {
      block: "",
      variant: "success"
    },
    on: {
      click: _vm.search
    }
  }, [_vm._v("\n          Rechercher\n        ")])], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-3",
    attrs: {
      cols: "12",
      lg: "3",
      "offset-lg": "3"
    }
  }, [_c("table", {
    staticClass: "table table-bordered",
    attrs: {
      id: "totals"
    }
  }, [_c("tbody", [_c("tr", {
    staticClass: "table-success"
  }, [_c("th", [_vm._v("Nombre de Tickets")]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.items.length))])]), _vm._v(" "), _vm.selected_radio !== "cafe" ? _c("tr", {
    staticClass: "table-danger"
  }, [_c("th", [_vm._v("Nombre de Personnes")]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.nummberPersons))])]) : _vm._e(), _vm._v(" "), _vm.selected_radio === "hammam" ? _c("tr", {
    staticClass: "table-warning"
  }, [_c("th", [_vm._v("Nombre de Remises")]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.nummberRemises))])]) : _vm._e(), _vm._v(" "), _c("tr", {
    staticClass: "table-info"
  }, [_c("th", [_vm._v("Total")]), _vm._v(" "), _c("td", [_vm._v(_vm._s(_vm.formatNumber(_vm.total_price)))])])])])])], 1)], 1), _vm._v(" "), _c("div", [_c("b-jumbotron", [_c("b-alert", {
    staticClass: "text-center mb-4",
    attrs: {
      show: "",
      variant: "success"
    }
  }, [_vm._v("\n        Caisse du : " + _vm._s(_vm.selected_radio === "piscine" ? "Piscine d'été" : _vm.selected_radio) + "\n      ")]), _vm._v(" "), _vm.selected_radio === "piscine_cov" ? _c("b-row", {
    staticClass: "mb-4"
  }, [_c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill text-center",
    attrs: {
      variant: "primary"
    }
  }, [_vm._v("\n              Hommes\n            ")])], 1)], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "primary"
    }
  }, [_vm._v("\n              +10 ans : " + _vm._s(_vm.nombrePiscineCov.h.cat_1) + "\n            ")]), _vm._v(" "), _c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "primary"
    }
  }, [_vm._v("\n              7-10 ans : " + _vm._s(_vm.nombrePiscineCov.h.cat_2) + "\n            ")])], 1)], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "primary"
    }
  }, [_vm._v("\n              2-7 ans : " + _vm._s(_vm.nombrePiscineCov.h.cat_3) + "\n            ")]), _vm._v(" "), _c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "primary"
    }
  }, [_vm._v("\n              -2 ans : " + _vm._s(_vm.nombrePiscineCov.h.cat_4) + "\n            ")])], 1)], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill text-center",
    attrs: {
      variant: "danger"
    }
  }, [_vm._v("\n              Femmes\n            ")])], 1)], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "danger"
    }
  }, [_vm._v("\n              +10 ans : " + _vm._s(_vm.nombrePiscineCov.f.cat_1) + "\n            ")]), _vm._v(" "), _c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "danger"
    }
  }, [_vm._v("\n              7-10 ans : " + _vm._s(_vm.nombrePiscineCov.f.cat_2) + "\n            ")])], 1)], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "danger"
    }
  }, [_vm._v("\n              2-7 ans : " + _vm._s(_vm.nombrePiscineCov.f.cat_3) + "\n            ")]), _vm._v(" "), _c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "danger"
    }
  }, [_vm._v("\n              -2 ans : " + _vm._s(_vm.nombrePiscineCov.f.cat_4) + "\n            ")])], 1)], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill text-center",
    attrs: {
      variant: "success"
    }
  }, [_vm._v("\n              Total\n            ")])], 1)], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "success"
    }
  }, [_vm._v("\n              +10 ans : " + _vm._s(_vm.nombrePiscineCov.h.cat_1 + _vm.nombrePiscineCov.f.cat_1) + "\n            ")]), _vm._v(" "), _c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "success"
    }
  }, [_vm._v("\n              7-10 ans : " + _vm._s(_vm.nombrePiscineCov.h.cat_2 + _vm.nombrePiscineCov.f.cat_2) + "\n            ")])], 1)], 1), _vm._v(" "), _c("b-col", {
    staticClass: "mb-2",
    attrs: {
      cols: "12"
    }
  }, [_c("b-list-group", {
    attrs: {
      horizontal: ""
    }
  }, [_c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "success"
    }
  }, [_vm._v("\n              2-7 ans : " + _vm._s(_vm.nombrePiscineCov.h.cat_3 + _vm.nombrePiscineCov.f.cat_3) + "\n            ")]), _vm._v(" "), _c("b-list-group-item", {
    staticClass: "flex-fill",
    attrs: {
      variant: "success"
    }
  }, [_vm._v("\n              -2 ans : " + _vm._s(_vm.nombrePiscineCov.h.cat_4 + _vm.nombrePiscineCov.f.cat_4) + "\n            ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c("div", [_c("b-table", {
    attrs: {
      "sticky-header": "",
      responsive: "",
      fields: _vm.selected_fields,
      items: _vm.items,
      "tbody-tr-class": _vm.rowClass,
      hover: "",
      "head-variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "cell(#)",
      fn: function (data) {
        return [_vm._v(_vm._s(data.index + 1))];
      }
    }, {
      key: "cell(gender)",
      fn: function (data) {
        return [_vm._v("\n            " + _vm._s(data.item.gender === "F" ? "Femme" : "Homme") + "\n          ")];
      }
    }, {
      key: "cell(discount)",
      fn: function (data) {
        return [_vm._v("\n            " + _vm._s(Math.floor(data.value * 100)) + "%\n          ")];
      }
    }, {
      key: "cell(action)",
      fn: function (row) {
        return [_c("b-button", {
          on: {
            click: function ($event) {
              return _vm.showDetails(row.item);
            }
          }
        }, [_vm._v("Afficher les Détails")])];
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c("b-modal", {
    attrs: {
      id: "cafeDetailsModal",
      size: "xl",
      title: "Détails de la commande",
      "header-text-variant": "dark"
    }
  }, [_c("b-container", {
    attrs: {
      fluid: ""
    }
  }, [_c("b-table", {
    attrs: {
      items: _vm.cafeorder_items,
      fields: _vm.cafeFields
    },
    scopedSlots: _vm._u([{
      key: "cell(#)",
      fn: function (data) {
        return [_vm._v(_vm._s(data.index + 1))];
      }
    }, {
      key: "cell(prix)",
      fn: function (data) {
        return [_vm._v("\n          " + _vm._s(_vm.formatNumber(data.item.qtt * data.item.price)) + "\n        ")];
      }
    }])
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };